import { formatDatePicker } from 'helpers/FormattingHelper';
import { IRON } from 'styles/Colors';
import { isFunction, isNumber } from 'lodash';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';

function RebrandDatePicker(props) {
  const {
    name,
    id,
    label,
    formControlStyle = {},
    value,
    error,
    maxDate,
    minDate,
    requiredStyle,
    onDatePickerChange,
    onTextFieldChange,
    onTouch,
    onBlur,
    onMount,
    isVisible,
    additionalProp
  } = props;
  const maximumAllowedDate = isNumber(additionalProp?.maxDate)
    ? moment().add(additionalProp?.maxDate, 'day')
    : moment().add(maxDate, 'day');
  const minimumAllowedDate = isNumber(additionalProp?.minDate)
    ? moment().add(additionalProp?.minDate, 'day')
    : moment().add(minDate, 'day');
  const [touched, setTouched] = useState(false);
  useEffect(() => {
    if (isFunction(onMount)) {
      onMount();
    }
  }, []);
  const handleChange = (newDate) => {
    const formattedDate = formatDatePicker(newDate);
    if (typeof formattedDate === 'string' && isFunction(onDatePickerChange)) {
      onDatePickerChange(formattedDate, minimumAllowedDate, maximumAllowedDate);
    }
    if ((touched || error) && isFunction(onTouch)) {
      onTouch(formattedDate, minimumAllowedDate, maximumAllowedDate);
    }
  };
  return (
    <>
      {isVisible && (
        <div css={formControlStyle}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={additionalProp?.label || label}
              onChange={handleChange}
              maxDate={maximumAllowedDate}
              minDate={minimumAllowedDate}
              maxLength={8}
              value={value}
              defaultCalendarMonth={
                new Date(
                  minimumAllowedDate.year(),
                  minimumAllowedDate.month(),
                  1
                )
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    style: { color: IRON },
                    htmlFor: id
                  }}
                  id={id}
                  name={name}
                  onBlur={(e) => {
                    setTouched(true);
                    onBlur(
                      e.target.value,
                      minimumAllowedDate,
                      maximumAllowedDate
                    );
                  }}
                  onChange={(e) => {
                    onTextFieldChange(
                      e.target.value,
                      minimumAllowedDate,
                      maximumAllowedDate
                    );
                  }}
                  error={!!error}
                  helperText={error}
                  FormHelperTextProps={{
                    style: { margin: '0', fontSize: '12px' }
                  }}
                  css={value === null || value === '' ? requiredStyle : {}}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      )}
    </>
  );
}

export default RebrandDatePicker;
